import { Label, LabelColor } from '@shared/components';

export type AdminProctorRequestStatusLabelVariant = 'in-review' | 'rejected';

interface AdminProctorRequestStatusLabelProps {
  variant: AdminProctorRequestStatusLabelVariant;
}

const ADMIN_PROCTOR_REQUEST_STATUS_COLOR: Readonly<
  Record<AdminProctorRequestStatusLabelVariant, LabelColor>
> = {
  'in-review': LabelColor.WARNING,
  rejected: LabelColor.ERROR,
};

const ADMIN_PROCTOR_REQUEST_STATUS_TEXT: Readonly<
  Record<AdminProctorRequestStatusLabelVariant, string>
> = {
  'in-review': 'คำขอที่รออนุมัติ',
  rejected: 'ไม่อนุมัติ',
};

export default function AdminProctorRequestStatusLabel(
  props: Readonly<AdminProctorRequestStatusLabelProps>,
) {
  const { variant } = props;

  return (
    <Label
      sx={{ px: (theme) => theme.spacing(3) }}
      color={ADMIN_PROCTOR_REQUEST_STATUS_COLOR[variant]}
      variant='outlined'
    >
      {ADMIN_PROCTOR_REQUEST_STATUS_TEXT[variant]}
    </Label>
  );
}
